// Единый разбор ошибок транспорта. SPEC client-transport §4.2 (единый разбор ErrorEnvelope) / §4.9.
//
// Любая не-2xx REST-ответка и WS-`error` приводятся к ОДНОЙ доменной ошибке `TransportError` с
// `code: ErrorCode` из shared-contracts. Конверт ошибки — `ErrorEnvelope = { error: {code,message,details?} }`
// (shared-contracts errors.ts). Если тело не разбирается как конверт (502 от прокси, обрыв, не-JSON) —
// синтезируем `code:'INTERNAL'`. Локальных дублей DTO/кодов модуль НЕ вводит (инвариант 4).
/**
 * Доменная ошибка транспорта. Несёт `code` из канонического перечня shared-contracts §4.3,
 * опциональный HTTP-`status` (для REST) и `details` конверта. `cause` — исходная ошибка (сеть/парс).
 */
export class TransportError extends Error {
    status;
    code;
    details;
    constructor(code, message, opts = {}) {
        super(message, opts.cause === undefined ? undefined : { cause: opts.cause });
        this.name = 'TransportError';
        this.code = code;
        this.status = opts.status;
        this.details = opts.details;
    }
}
/** Набор кодов из конверта — для рантайм-валидации тела (форма приходит из shared-contracts). */
const ERROR_CODES = new Set([
    'UNAUTHENTICATED',
    'FORBIDDEN',
    'NOT_FOUND',
    'VALIDATION',
    'CONFLICT',
    'RATE_LIMITED',
    'PAYLOAD_TOO_LARGE',
    'ASR_UNAVAILABLE',
    'INTERNAL',
]);
/** Узкая проверка: тело — это валидный `ErrorEnvelope` (есть `error.code`/`error.message`). */
export function isErrorEnvelope(body) {
    if (typeof body !== 'object' || body === null)
        return false;
    const err = body.error;
    if (typeof err !== 'object' || err === null)
        return false;
    const code = err.code;
    const message = err.message;
    return typeof code === 'string' && ERROR_CODES.has(code) && typeof message === 'string';
}
/**
 * Маппит конверт/произвольное тело не-2xx ответа в `TransportError`. Если тело — валидный
 * `ErrorEnvelope`, берём его `code/message/details`; иначе синтезируем `INTERNAL` (например, 502
 * от reverse-proxy с HTML-телом, или нечитаемое тело). HTTP-`status` сохраняем всегда.
 */
export function envelopeToError(status, body) {
    if (isErrorEnvelope(body)) {
        const e = body.error;
        return new TransportError(e.code, e.message, { status, details: e.details });
    }
    return new TransportError('INTERNAL', `HTTP ${status}`, { status });
}
/**
 * Ошибка уровня транспорта (нет сети, обрыв, отмена по таймауту, не-`AbortError` от fetch).
 * Сетевые сбои — не доменный конверт: классифицируем как `INTERNAL` без HTTP-`status`.
 */
export function networkToError(cause, message = 'network error') {
    return new TransportError('INTERNAL', message, { cause });
}
//# sourceMappingURL=errors.js.map